import { render } from "./VaccinationAdvice.vue?vue&type=template&id=d7d49bd8"
import script from "./VaccinationAdvice.vue?vue&type=script&lang=js"
export * from "./VaccinationAdvice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__